// extracted by mini-css-extract-plugin
module.exports = {"faq":"faq-module--faq--ouBIs","faqAnswer":"faq-module--faqAnswer--LBFQv","faqAnswerInner":"faq-module--faqAnswerInner--RX4jD"};